module.exports = __webpack_public_path__ + "static/lubricante_de_riego-fd5dae1aba74a0c7ed99adb2fa9b7ac0.png";